import React, { Component }  from 'react';
import Map                   from './../components/Map/containers/MapContainer';
import PlaceInfo             from './Place/containers/PlaceInfoContainer';
import _                     from 'lodash';

class PlaceMap extends Component {

    state = {
        showInfoWindow: false,
        directions    : null
    };

    componentWillMount = () =>
    {
        if (null !== this.props.directions.result)
        {
            this.props.resetDirections();
        }
    };

    //---------------------------------------------------------------------------------------------------------------

    componentWillReceiveProps = (nextProps) =>
    {
        if (nextProps.selected !== this.props.selected && null !== this.props.directions.result)
        {
            this.props.resetDirections();
        }
        else if (nextProps.directions.show !== this.props.directions.show || nextProps.geo.coords !== this.props.geo.coords)
        {
            this.saveDirections(nextProps);
        }
    };

    //---------------------------------------------------------------------------------------------------------------

    closeInfoWindow = () =>
    {
        this.setState({ showInfoWindow: false });
    };

    //---------------------------------------------------------------------------------------------------------------

    saveDirections = (props) =>
    {
        if (props.directions.show === true && null !== props.geo.coords && typeof props.selected !== 'undefined')
        {
            let origin      = { lat: props.geo.coords.latitude, long: props.geo.coords.longitude };
            let destination = { lat: props.place.coords.lat, long: props.place.coords.long };
            this.props.fetchDirections(origin, destination);
        }
        else
        {
            this.props.resetDirections();
        }
        this.closeInfoWindow();
    };

    //---------------------------------------------------------------------------------------------------------------

    isTrail = () =>
    {
        return ('trail' === this.props.place.type);
    };

    //---------------------------------------------------------------------------------------------------------------

    render = () =>
    {
        let otherPlaces = this.props.place.tags.length === 0 ? [] : this.props.places.slice(0);

        if (otherPlaces.length > 0)
        {
            _.remove(otherPlaces, (place) =>
            {
                if (place.id === this.props.place.id) {
                    return true;
                } else {
                    const compare = _.intersection(place.tags, this.props.place.tags);
                    return !(compare.length > 0);
                }
            })
        }

        let map = (
            <Map
                places={ this.isTrail() ? [] : [this.props.place] }
                otherPlaces={ this.isTrail() ? otherPlaces : [] }
                kml={ this.isTrail() ? { url: this.props.place.kmlFile } : null }
            />
        );

        let details;

        if (this.isTrail())
        {
            details = <div className="place-container"><PlaceInfo/></div>;
        }

        return (<div>{ map }{ details }</div>)
    }
}

export default PlaceMap;



// WEBPACK FOOTER //
// ./src/components/PlaceMap.js